import { Node } from "@xyflow/react";
import { atom } from "jotai";
import { canvasAtom } from "../canvas/canvasAtom";
import { deriveZslFromCanvas } from "../utils";
import { isAiPageAtom } from "../templates/isAiPageAtom";
import { togglesAtom } from "../diagramming/togglesAtom";
import { zslAtom } from "../templates/zslAtom";
import { isStreamingZslAtom } from "../../../streaming/src/atoms/streamingStatusAtoms";
// Create a base atom for the nodes state
const baseNodesAtom = atom<Node[]>([]);
baseNodesAtom.debugLabel = "baseNodesAtom";

export const nodesAtom = atom<
  Node[],
  [Node[] | ((prev: Node[]) => Node[])],
  void
>(
  // Getter
  (get) => get(baseNodesAtom),
  // Setter
  (get, set, update: Node[] | ((prev: Node[]) => Node[])) => {
    // Get current nodes state
    const currentNodes = get(baseNodesAtom);
    const isStreamingZsl = get(isStreamingZslAtom);
    // Apply the update (handling both direct and functional updates)
    const newNodes =
      typeof update === "function" ? update(currentNodes) : update;

    // Update nodes state
    set(baseNodesAtom, newNodes);

    // Get current canvas
    const canvas = get(canvasAtom);
    const isAiPage = get(isAiPageAtom);
    const toggles = get(togglesAtom);

    // Update ZSL state using the utility function
    if (isAiPage && !isStreamingZsl && toggles.aiCanvasComposer) {
      const currentZsl = get(zslAtom);
      if (currentZsl) {
        const updatedZsl = deriveZslFromCanvas(currentZsl, canvas, newNodes);
        if (updatedZsl) {
          set(zslAtom, updatedZsl);
        }
      }
    }
  },
);
nodesAtom.debugLabel = "nodesAtom";
